// import { Trans } from '@lingui/react';
import React, { useContext } from 'react';
import { Redirect } from 'react-router';
import { Button, Row, Col} from 'reactstrap';
import { AuthContext } from '../context/AuthContext';
import FormComponent from '../components/FormComponent';
import ExternalLayout from '../components/layouts/ExternalLayout';
import MfaModal from './MfaModal';

const LoginForm = FormComponent({
    displayName: 'Login',
    schema: {
        title: "Login",
        type: "object",
        properties: {
            email: { title: "Email", type: "string" },
            password: { title: "Password", type: "string" },
        },
        required: ["email", "password"],
    },
    uiSchema: {
        "password": { "ui:widget": "password" },
    },
    parseProps: ({ auth }) => ({ auth }),
    async onSubmit({ formData: { email, password } }, { props: { auth } }) {
        await auth.login({ email, password });
    },
    renderFormChildren: ({ history }) => {
        function forgotPassword() {
            history.push("/forgot-password")
        }

        return (<>
            <Row>
            <Col><Button color="primary" type="submit" data-cy="submit" block>Acceder</Button></Col>
                <Col><Button color="link" onClick={forgotPassword} block>Olvidé mi contraseña</Button></Col>
            </Row>
            <hr />

            <div className="text-center">
                <h5 className="text-bold">¿Necesitas crear una cuenta?</h5>
                <p className="text-bold">Ponte en contacto con tu administrador de sistemas</p>
                {/* <Button color="primary" outline onClick={signUp} block>Registrarme</Button> */}
            </div>
        </>);
    },
    // renderFormSubmitted: () => (
    //     <Redirect path="/" />
    // ),
    withoutNavigation: true
});

const Login = ({ history }) => {
    const auth = useContext(AuthContext);

    return (<ExternalLayout>
        <div className="col col-md-6 offset-md-3 div-login" >
        {
            auth.isLoggedIn ? (
                <Redirect path="/" />
            ) :(
                <div>
                    <LoginForm history={history} auth={auth} />
                    <MfaModal />
                </div>
            )
        }
        </div>
    </ExternalLayout>);
}

export default Login;